import type { AgentPart } from "../agent-event.ts";

type AnswerPart = Extract<AgentPart, { type: "question_answer" }>;

/**
 * Lo que el usuario contestó a una tarjeta de preguntas (1.7).
 *
 * Vive en SU mensaje --es lo que él dijo-- y se lee como una lista corta:
 * qué se preguntaba y qué eligió. Lo escrito a mano se distingue de lo
 * elegido, porque no es lo mismo escoger una opción del agente que salirse
 * de ellas.
 */
export function GivenAnswers({ part }: { part: AnswerPart }) {
  return (
    <div className="grid gap-2">
      <dl className="grid gap-1.5 text-sm">
        {part.answers.map((answer) => (
          <div key={answer.key} className="grid gap-0.5">
            <dt
              className="text-xs text-muted-foreground"
              title={answer.question}
            >
              {answer.header}
            </dt>
            <dd>
              {answer.selected.join(" · ")}
              {answer.custom !== undefined && (
                <>
                  {answer.selected.length > 0 && " · "}
                  <span className="italic">“{answer.custom}”</span>
                </>
              )}
            </dd>
          </div>
        ))}
      </dl>
      {part.note !== undefined && (
        <p className="border-t pt-2 text-sm whitespace-pre-line">{part.note}</p>
      )}
    </div>
  );
}
